import { getTrainConfig } from '@/utils/http/modules/course/course.request'
import { getParams, usePcPage } from './utils'
import store from '@/store'
import muTypes from '@/store/mutation-types.js'

function trainToPcPage() {
  if (usePcPage) {
    let url = ''
    const { id, ...params } = getParams()
    const origin = window.location.origin
    switch (window.location.pathname) {
      case '/live/m/course/detail':
        url = `${origin}/live/page/train/course/${id}?`
        break
      case '/live/m/special/detail':
        url = `${origin}/live/page/train/special/${id}?`
        break
      case '/live/m/camp/detail':
        url = `${origin}/live/page/train/camp/${id}?`
        break
      case '/live/m/audio/detail':
        url = `${origin}/live/page/train/audio/${id}?`
        break
      case '/live/m/image-text/detail':
        url = `${origin}/live/page/train/imageText/${id}?`
        break
      case '/live/m/video/detail':
        url = `${origin}/live/page/train/video/${id}?`
        break
    }
    if (url) {
      Object.keys(params).forEach((key, index) => {
        url += `${index == 0 ? '' : '&'}${key}=${params[key]}`
      })
      console.log('replace:', url)
      window.location.replace(url)
    }
  }
}
function getRelateType() {
  if (location.pathname.includes('audio')) {
    return 0
  } else if (location.pathname.includes('video')) {
    return 1
  } else if (location.pathname.includes('image-text')) {
    return 3
  } else if (location.pathname.includes('course')) {
    return 4
  } else if (location.pathname.includes('special')) {
    return 5
  } else if (location.pathname.includes('camp')) {
    return 6
  } else {
    return ''
  }
}
export async function useTrainConfig() {
  try {
    return new Promise(resolve => {
      if (
        [
          '/live/m/audio/detail',
          '/live/m/course/detail',
          '/live/m/video/detail',
          '/live/m/image-text/detail',
          '/live/m/camp/detail',
          '/live/m/special/detail',
        ].includes(window.location.pathname)
      ) {
        getTrainConfig({})
          .then(res => {
            if (res.code == 0) {
              if (res.data.enablePCTrain && usePcPage) {
                trainToPcPage()
              } else {
                store.commit(muTypes.zbvd, res.data)
                resolve()
              }
            } else {
              resolve()
            }
          })
          .catch(err => {
            console.log(err)
            resolve()
          })
        updateTrainConfig({
          relateType: getRelateType(),
          relateId: getParams().id,
        })
      } else {
        resolve()
      }
    })
  } catch (error) {
    console.log(error)
    return Promise.resolve(false)
  }
}

let lastRequestTrainConfigParams = {
  relateType: null,
  relateId: null,
}
/**
 * 更新训练配置（处理页面重复请求）
 * @param {*} params 训练配置参数
 * @param {*} force 是否强制更新
 */
export function updateTrainConfig(params = {}, force = false) {
  if (
    lastRequestTrainConfigParams.relateId === params.relateId &&
    lastRequestTrainConfigParams.relateType === params.relateType &&
    !force
  ) {
    return
  }
  lastRequestTrainConfigParams = params
  store.dispatch('updateTrainConfig', params)
}
